<template>
    <section class="liste-modeles-analyse main-section">
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="h-left animate animate-fadeInLeft">
                    <h1 class="p-title">
                        <span class="text-primary">Paramètres</span> |
                        <a class="text-primary" href="javascript:void(0);" @click="$router.go(-1)">Modèles d’analyse</a> |
                        <span>{{ mode === "edit" ? "Modifier le modèle" : "Créer un modèle" }}</span>
                    </h1>
                </div>
            </div>
        </div>

        <ModelMetaHead /> -->
        <div class="show-on-fixed pane-fixed">
            <div class="card brder-radius-x">
                <div class="card-body brder-radius-x">
                    <h1 class="p-title">
                        <span class="text-primary">Paramètres</span> |
                        <a class="text-primary" href="javascript:void(0);" @click="$router.go(-1)">Modèles d’analyse</a> |
                        <span>{{ mode === "edit" ? "Modifier le modèle" : "Créer un modèle" }}</span>
                    </h1>

                    <div class="flx flx__wrap flx-start mt-3">
                        <div class="flx__ctn--02">
                            <span class="font-wgh-600">Nom et Prénoms : </span>
                            <span>
                                -
                            </span>
                        </div>

                        <div class="flx__ctn--02">
                            <span class="font-wgh-600">Age : </span> <span>-</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="font-wgh-600">&nbsp;&nbsp;Sexe : </span> <span>-</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="font-wgh-600">&nbsp;&nbsp;Téléphone : </span>-
                        </div> 
                    </div>

                    <div class="flx flx__wrap flx-start flx__gap--02 mt-2">
                        <div class="">
                            <span class="font-wgh-600">Médecin demandeur : </span> -
                        </div>

                        <div class="">
                            <span class="font-wgh-600">Renseignement clinique : </span> -
                        </div> 
                    </div>

                    <div class="flx flx__wrap flx-start flx__gap--02 mt-2">
                        <div class="">
                            <span class="font-wgh-600">Technique utilisée : </span> -
                        </div>
                    </div>
                </div>
            </div>

            <div class="card brder-radius-x mt-2">
                <ClipBoard />
            </div>
        </div>

        <div class="card section-body top-320 scroll-bar brder-radius-x">
            <div class="card animate animate-fadeIn w-100">
                <!-- Messages d'erreurs venant de l'API -->
                <div class="row mt-2" v-if="errors">
                    <b-alert show variant="danger" class="col mx-4" dismissible>
                        <div v-for="(error, field) in errors" :key="field">
                            <ul>
                                <li v-for="message in error" :key="message">{{ message }}</li>
                            </ul>
                        </div>
                    </b-alert>
                </div>
                <ValidationObserver ref="observer" tag="form">
                    <div class="card-body model-analyse-form">
                        <div class="row">
                            <div class="col mr-2">
                                <CCAInput
                                    required
                                    label="Nom du modèle"
                                    v-model="model.name"
                                    placeholder="Entrer le nom du modèle"
                                    inputRef="name"
                                />
                            </div>

                            <div class="col">
                                <CCAMultiSelect
                                    required
                                    refName="analyse"
                                    inputLabel="Nom de l’analyse"
                                    v-model="selectedAnalyse"
                                    placeholder="Sélectionner l’analyse"
                                    :options="analyses"
                                    optionLabel="nom"
                                />
                            </div>
                        </div>

                        <fieldset class="border rounded-lg p-3 my-2">
                            <legend class="legend">Tableau de résultats</legend>

                            <CCAInput
                                v-model="model.meta.table_header_name"
                                placeholder="Entête du tableau"
                                inputRef="table_header_name"
                            />
                            <fieldset class="border rounded p-3 my-2">
                                <legend class="legend">Colonnes</legend>
                                <div class="row mb-3">
                                    <div class="col mr-2" v-for="(_, index) in model.meta.rows[0].cells" :key="index">
                                        <CCAInput
                                            required
                                            inputRef="columns"
                                            v-model="model.meta.rows[0].cells[index].value"
                                            placeholder="Entrer le nom de la colonne"
                                        />
                                        <span v-if="index > 1" class="text-danger cursor-pointer float-right h-8p" @click="removeColumn(index)">
                                            <i class="ic-cancel h-8p ic-danger"></i>
                                            Supprimer
                                        </span>
                                    </div>

                                    <div class="col-auto">
                                        <button class="btn btn-primary btn-radius" @click.prevent="addColumn" :disabled="currentColumnCount >= 4">
                                            <i class="ic-plus h-13p"></i> Ajouter
                                        </button>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="border rounded px-3 pb-4 mb-3" v-if="model.meta.rows.length > 1">
                                <legend class="legend">Lignes</legend>

                                <div class="row mt-2" v-for="(line, lineIndex) in rows" :key="lineIndex">
                                    <div class="col mr-2" v-for="(cell, cellIndex) in line.cells" :key="cellIndex">
                                        <template v-if="!cell.subcells || cell.subcells.length === 0">
                                            <CCAInput v-model="cell.value" />
                                        </template>
                                        <div v-else :class="cell.horizontal ? 'd-flex flex-row' : 'd-flex flex-column'">
                                            <div v-for="(subcell, index) in cell.subcells" :key="index" class="w-100 mb-1" :class="{ 'mr-1': cellIndex !== cell.subcells.length }">
                                                <CCAInput v-model="subcell.value" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-auto">
                                        <button class="btn btn-secondary-light-o btn-radius dropdown-toggle"
                                            data-toggle="dropdown">
                                            <i class="ic-more ic-secondary h-13p"></i> Actions
                                        </button>
                                        <div class="dropdown">
                                            <ul class="dropdown-menu dropdown-menu-right animate animate-zoomIn"
                                                style="min-width: 230px;">
                                                <li>
                                                    <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                        @click="openSubdivideCellModal(lineIndex)">
                                                        <i class="ic-category"></i> &nbsp;
                                                        Subdiviser une cellule
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" class="text-secondary ml-auto"
                                                        @click="removeLine(lineIndex)" id="#deleteLigneBtn">
                                                        <i class="ic-trash-outline"></i> &nbsp;
                                                        Supprimer la ligne
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row justify-content-end mt-4">
                                <div class="col-auto text-primary cursor-pointer" @click="addLine">
                                    <i class="ic-plus h-13p ic-primary-sg"></i> Ajouter une ligne
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-center justify-content-center empty-zone mt-4" v-if="rows.length === 0">
                                <i class="ic-info-empty scale-2-5"></i>
                                <br />
                                <p>Aucune ligne ajoutée au tableau pour l’instant!</p>
                            </div>

                        </fieldset>

                        <div class="row mt-4">
                            <div class="col">
                                <h6>Visibilité</h6>
                            </div>
                            <div class="col-auto">
                                <b-form-checkbox v-model="isModelActive" switch>
                                    {{ isModelActive ? 'Actif' : 'Inactif' }}
                                </b-form-checkbox>
                            </div>
                        </div>

                        <div class="row justify-content-end mt-4">
                            <div class="col-auto">
                                <button type="button" class="btn btn-secondary-light-o btn-radius" @click="$router.go(-1)">
                                    Annuler tout
                                </button>
                            </div>
                            <div class="col-auto ml-2" v-if="rows.length >= 1">
                                <button type="button" class="btn btn-primary-o btn-radius" data-toggle="modal"
                                    data-target=".preview-modal-lg" :disabled="rows.length === 0 || !isTableReadyToPreview">
                                    Prévisualiser
                                </button>
                            </div>
                            <div class="col-auto ml-2">
                                <button type="button" class="btn btn-primary btn-radius" :disabled="isModelSaving"
                                    @click="saveModeleAnalyse">
                                    Enregistrer
                                    <div v-if="isModelSaving" class="spinner-border text-white" role="status">
                                        <span class="sr-only ">Loading...</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </div>

        <SplitCellModal ref="subdivideCellModal"
            :modalTitle="`Subdiviser une cellule de la : ligne ${selectedLine.toString().padStart(2, '0')}`"
            modalId="subdivide-cell-modal" @appliedCellSplit="onAppliedCellSplit" :cellOptions="cellOptions" />

        <ConfirmationModal id="delete-confirm-modal" @confirm="onDeleteConfirmCallback">
            <template v-slot:subtitle>{{ deleteConfirmSubtitle }}</template>
            <strong slot="subtitle2">{{ deleteConfirmSubtitle2 }}</strong>
        </ConfirmationModal>

        <PreviewModelFullModalVue :model="model" />
    </section>
</template>
  
<script>
import ClipBoard from '@/components/clipboard';
import ConfirmationModal from '@/components/dialogs/ConfirmationModal.vue';
import CCAInput from '@/components/inputs/CCAInput.vue';
import CCAMultiSelect from '@/components/inputs/CCAMultiSelect.vue';

import PreviewModelFullModalVue from './components/PreviewModelFullModal.vue';
import SplitCellModal from './components/SplitCellModal.vue';

import { showToast } from '@/utils/notifications';
import $ from 'jquery';

export default {
    name: "editer-modele-analyse",
    components: {
        PreviewModelFullModalVue, CCAInput, CCAMultiSelect,
        SplitCellModal, ConfirmationModal, ClipBoard
    },
    props: [],
    data() {
        return {
            model: {
                name: "",
                analyse_id: null,
                meta: {
                    table_header_name: "",
                    rows: [{ cells: [{ value: "" }, { value: "" }] }],
                },
                status: "active",
            },
            isModelActive: true,

            selectedAnalyse: null,

            selectedLine: 0,
            selectedDisposition: "horizontal",
            dispositionOptions: [
                { item: "horizontal", name: "Horizontale" },
                { item: "vertical", name: "Verticale" },
            ],
            cellOptions: [
                {
                    label: "Cellule 02",
                    value: 1,
                }
            ],
            selectedCell: null,

            deleteConfirmSubtitle: "",
            deleteConfirmSubtitle2: "",
            onDeleteConfirmCallback: () => { },

            isModelSaving: false,
            errors: null,
        };
    },

    computed: {
        analyses() {
            return this.$store.getters["analyses"];
        },
        modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },
        rows() {
            if (this.model.meta.rows.length > 1) {
                return this.model.meta.rows.slice(1);//Ignorer les lignes d'en-tête
            }
            return [];
        },
        currentColumnCount() {
            const { rows } = this.model.meta;

            return rows[0].cells.length; // Nombre de colonnes dans la première ligne
        },
        isTableReadyToPreview() {
            const { rows } = this.model.meta;

            const isFirstRowFilled = rows && rows[0].cells.every(cell => cell.value && cell.value?.trim().length > 0);
            // const isEveryCellFirstColumnFilled = rows.every(row => row.cells[0].value.trim().length > 0);

            return isFirstRowFilled;
        },
        mode() {
            const { id } = this.$route.params;
            return id && this.modele_analyse ? "edit" : "create";
        }
    },

    watch: {
        selectedAnalyse: {
            handler(newValue) {
                if (newValue && newValue.id) {
                    this.model.analyse_id = newValue.id;
                }
            },
        },
        isModelActive: {
            handler(newValue) {
                this.model.status = newValue ? "active" : "inactive";
            },
        },
    },

    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);

        if (this.mode === "edit") {
            this.model = this.modele_analyse;
            this.selectedAnalyse = this.modele_analyse.analyse;

            this.isModelActive = this.modele_analyse.status === "active";

            if(this.currentColumnCount === 4) {
                this.cellOptions.push(this.generateNextCellOption());
                this.cellOptions.push(this.generateNextCellOption());
            } 

            if(this.currentColumnCount === 3) {
                this.cellOptions.push(this.generateNextCellOption());
            }
        }
    },

    methods: {
        addColumn() {
            const { rows } = this.model.meta;
            const maxColumns = 4;

            if (this.currentColumnCount < maxColumns) {
                const newCellOption = this.generateNextCellOption();
                this.cellOptions.push(newCellOption);

                rows.forEach((row) => row.cells.push({ value: "" }));
            }
        }
        ,

        removeColumn(index) {
            this.deleteConfirmSubtitle = "Êtes-vous sur de vouloir supprimer la colonne :";
            this.deleteConfirmSubtitle2 = `N° ${index + 1} ?`;

            this.onDeleteConfirmCallback = () => {
                const { rows } = this.model.meta;

                rows.forEach((row) => {
                    if (row.cells.length > 1) {
                        row.cells.splice(index, 1);
                    }
                });
            };

            this.cellOptions.pop();

            this.$bvModal.show("delete-confirm-modal");
        },

        addLine() {
            const { rows } = this.model.meta;

            if (rows.length > 0) {
                const columns = rows[0].cells;
                const newRow = { cells: new Array(columns.length).fill({ value: "" }) };

                const newRows = [...rows, newRow];

                this.model.meta.rows = JSON.parse(JSON.stringify(newRows));
            }
        },

        removeLine(index) {
            this.deleteConfirmSubtitle = "Êtes-vous sur de vouloir supprimer la ligne :";
            this.deleteConfirmSubtitle2 = `N° ${index + 1} ?`;

            this.onDeleteConfirmCallback = () => {
                this.model.meta.rows.splice(index + 1, 1);
            };

            this.$bvModal.show("delete-confirm-modal");
        },

        onAppliedCellSplit({ numberOfCells, disposition, selectedCellIndex }) {
            const lineIndex = this.selectedLine - 1;
            
            const cellToUpdate = this.rows[lineIndex].cells[selectedCellIndex];
            const isHorizontal = disposition === "horizontal";

            if (numberOfCells >= 2) {
                const subcells = new Array(numberOfCells).fill("").map(() => ({ value: "" }));
                this.$set(cellToUpdate, "subcells", subcells);
                this.$set(cellToUpdate, "horizontal", isHorizontal);
            } else {
                this.$set(cellToUpdate, "subcells", []);
                this.$set(cellToUpdate, "horizontal", false);

                this.$set(this.rows, lineIndex, { ...this.rows[lineIndex] });
            }

            this.$bvModal.hide('subdivide-cell-modal');
        },


        async saveModeleAnalyse() {
            this.errors = null;// Réinitialisation des erreurs

            const isValid = await this.$refs.observer.validate();

            if (isValid) {
                // Vérification du nombre de lignes dans le modèle
                if (this.model.meta.rows.length <= 1) {
                    showToast("Veuillez ajouter au moins deux lignes", "error");
                } else {
                    try {
                        this.isModelSaving = true;

                        let response = null;

                        if(this.mode === "create") {
                            response = await this.$store.dispatch("saveModeleAnalyse", this.model);
                        }else {
                            response = await this.$store.dispatch("updateModeleAnalyse", this.model);
                        }

                        this.isModelSaving = false; // Termine le chargement

                        if (response?.status === 201 || response?.status === 200) {
                            const action = this.mode === "create" ? "enregistré" : "mis à jour";

                            showToast(`Modèle d'analyse ${action} avec succès`, "success");

                            // Redirige vers la liste des modèles d'analyse après un délai
                            setTimeout(() => {
                                this.$router.push({ name: "listeModelesAnalyse" });
                            }, 1000);
                        }
                    } catch (error) {
                        this.isModelSaving = false; // Termine le chargement

                        // Gestion des erreurs de sauvegarde
                        if (error.response.status === 422 || error.response.status === 400) {
                            this.errors = error.response.data.errors;
                            showToast("Une ou plusieures erreurs de validation ont été relevé", "error");
                        } else {
                            showToast("Erreur lors de la sauvegarde. Veuillez réessayer!", "error");
                        }
                    }
                }
            }
        },

        openSubdivideCellModal(index) {
            this.selectedLine = index + 1;

            this.$bvModal.show('subdivide-cell-modal');
        },

        generateNextCellOption() {
            const lastCellOption = this.cellOptions[this.cellOptions.length - 1];

            const newCellOption = {
                label: `Cellule ${(lastCellOption.value + 2).toString().padStart(2, '0')}`,
                value: lastCellOption.value + 1,
            };

            return newCellOption;
        },

    },
};
</script>
  
<style src="./styles/index.scss" scoped lang="scss"></style>